export default __webpack_public_path__ + "static/media/all_agents_datatable.cb1b8d29.png";